import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, observable } from 'rxjs';
import { Subject } from 'rxjs';
import { User } from '../../interface/user/user';
import { HttpService } from '../http/http.service';
import { UserSettings } from '../../interface';
import { Role } from '../../interface/role/Role';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  settings: BehaviorSubject<UserSettings> = new BehaviorSubject<UserSettings>(null);
  constructor(private _http: HttpService) {
    this.settings.next({
      currency: 'PKR',
      language: 'English'
    });
  }

  getUser() {
    return this._http.get('/Users');
  }
  public async get(id: number): Promise<User> {
    return firstValueFrom(this._http.get('/Users/' + id));
  }
    public async getAll(): Promise<User[]> {
    return firstValueFrom(this._http.get('/Users/'));
  }
  public update(id: number, data: User): Promise<User> {
    return firstValueFrom(this._http.patch('/Users/', id, data));
  }
  public create(data: User): Promise<User> {
    return firstValueFrom(this._http.post('/Users', data));
  }
  getuserbyid(id: number) {
    return this._http.get('/Users/' + id);
  }
  public delete(id: number): Promise<void> {
    return firstValueFrom(this._http.delete('/Users/', id));
  }
  public getRoles(): Promise<Role[]> {
    return firstValueFrom(this._http.get('/Roles'));
  }


}
